import { LoginInProgressAuthError } from '@ms/yammer-web-authenticators';

import { isInteractiveLoginRequiredAuthError } from './isInteractiveLoginRequiredAuthError';

export type IsPermanentFailure = (error: unknown) => boolean;
export const isPermanentFailure: IsPermanentFailure = (error) =>
  !(error instanceof LoginInProgressAuthError) && !isInteractiveLoginRequiredAuthError(error);
